// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3tjxF","content":"LoadingAlert_content__CAm6g"};